import { PERMISSION_NAME } from 'v2/utils/permissions';
import { useHasAnyPermission } from './useHasAnyPermission';

export function useIsConnectUser(): boolean {
  return useHasAnyPermission([PERMISSION_NAME.CREATE_SEARCH]);
}
